import '../../../../css/buttons.css';
import type { ButtonProps } from '../../types/button';

const ButtonDefault = ({ onClick, testId, className, children, ...otherProps }: ButtonProps) => (
    <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className={`btn btn-default ${className ?? ''}`}
        {...otherProps}
    >
        {children}
    </button>
);

export default ButtonDefault;
